import React from "react";
import { Select } from "antd";
import { messages } from "../../../utils/Common/Messages";
import { getUserData } from "../../../utils/Helpers";
const { Option } = Select;

const Paymenttype = (props) => {
  const lan = getUserData().language ?? "EN";
  const tip = getUserData().tip ?? false;
  const creditCardFee = getUserData().creditCardFee ?? false;
  const vatReturnReport = getUserData().country == 236 ? "vatReturnReport" : false;
  const isNigeria = getUserData().country == 18;
  const ITU_cellP = getUserData()?.ITU_cellP === true || getUserData()?.ITU_cellpay === "true";
  const webLite = getUserData()?.webLite ?? false;
  const crypto = getUserData()?.crypto ?? false;
  const appLite = getUserData()?.appLite ?? false;
  const { setPayment, currencySign } = props;
  const selectOnChange = (value) => {
    setPayment(value);
  };
  return (
    <>
      <div className="mb-05">
        <label title={messages.selectPaymentType[lan]}>
          {messages.selectPaymentType[lan]}
        </label>
      </div>
      <Select
        placeholder={messages.selectPaymentType[lan]}
        style={{ width: "100%" }}
        onChange={selectOnChange}
        defaultValue="all"
      >
        <Option value="all">{messages.all[lan]}</Option>
        <Option value="cash">{messages.cash[lan]}</Option>
        <Option value="card">{messages.card[lan]}</Option>
        {currencySign === "$" ? (
          <Option value="ebt">{messages.EBT[lan]}</Option>
        ) : (
          ""
        )}
        <Option value="custom_payment">{messages.customPayment[lan]}</Option>
        {tip ? <Option value="tip">{messages.tip[lan]}</Option> : ""}
        <Option value="other">{messages.other[lan]}</Option>
        {webLite != true && appLite != true ? (
          <Option value="customerInvoice">
            {messages.customerInvoice[lan]}
          </Option>
        ) : (
          ""
        )}
       {vatReturnReport ? (<Option value="tax">{messages.vat[lan]}</Option>): (<Option value="tax">{messages.tax[lan]}</Option>)}
       {vatReturnReport ? "" : (<Option value="nontax">{messages.nontax[lan]}</Option>)}
        <Option value="taxExempt">{messages.taxExempt[lan]}</Option>
        <Option value="cashInOut">{messages.cashInOut[lan]}</Option>
        {creditCardFee ? <Option value="creditCardFee">{messages.CreditCardFee[lan]}</Option> : ""}
        {vatReturnReport ? <Option value="vatReturnReport">{messages.vatReturnReport[lan]}</Option> : ""}
        {crypto == true ? (<Option value="crypto">{messages.crypto[lan]}</Option>) : ""}
        {!isNigeria ? <Option value="receivables">{messages.receivables[lan]}</Option> : ""}
        {ITU_cellP ? (
          <Option value="cellPayMerchantFee">{messages.cellPayMerchantFee[lan]}</Option>
        ) : (
          ""
        )}
      </Select>
    </>
  );
};
export default Paymenttype;
